/**
 * @typedef { import('./EventWebinarDetail').EventWebinarDetail } EventWebinarDetail
 */

import styled from 'styled-components';
import { getWindow } from 'ssr-window';
import { useEffect, useState } from 'react';
import { useLocalization } from '../../custom-hooks/useLocalization';
import ButtonLink from '../../shared/ButtonLinkComponent';
import { useEventWebinarContext } from './EventWebinarContext';
import SocialMediaIntentList from './SocialMediaIntentList';

const ContactName = styled.p`
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 2.4rem;
  margin-top: 0;
`;

const Address = styled.address`
  margin-block: 1.6rem;
  font-style: normal;
`;

const SectionTitle = styled.p`
  margin: 0;
  text-transform: uppercase;
  font-size: 1.2rem;
  line-height: 1.6rem;
  letter-spacing: 0.7px;
`;

const PhoneNumber = styled.a`
  font-weight: 700;
`;

const LineBreak = styled.hr`
  border: none;
  background: var(--grey);
  height: 1px;
  margin-block: 1.6rem;
  width: 100%;
`;

const ContactAndConnect = ({ className, eventTypeDisplayName, hideSocialShare }) => {
  const window = getWindow();
  const { resourceStrings } = useLocalization();
  const { contactName, contactEmail, technicalSupportPhone, bdoEmployeesPhone, title } =
    useEventWebinarContext();
  const [obfuscatedEmail, setObfuscatedEmail] = useState();

  useEffect(() => {
    setObfuscatedEmail(window.btoa(contactEmail));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contactEmail]);

  const handleMailTo = (e) => {
    e.preventDefault();

    window.open(`mailto:${window.atob(obfuscatedEmail)}`, '_blank');
  };

  return (
    <section className={className}>
      <Address>
        <SectionTitle>
          {resourceStrings['bdO.EventsWebinars.ContactAndConnect.Contact']}
        </SectionTitle>
        <ContactName>{contactName}</ContactName>
        <ButtonLink
          type="icon-tertiary"
          text="Email"
          size="small"
          link={`mailto:${obfuscatedEmail}`}
          icon="mail"
          theme="light"
          onClickFunction={handleMailTo}
        />
      </Address>
      <LineBreak />
      <Address>
        <SectionTitle>
          {resourceStrings['bdO.EventsWebinars.ContactAndConnect.TechnicalSupport']}
        </SectionTitle>
        <PhoneNumber href={`tel:${technicalSupportPhone}`}>{technicalSupportPhone}</PhoneNumber>
      </Address>
      <Address>
        <SectionTitle>
          {resourceStrings['bdO.EventsWebinars.ContactAndConnect.BdoEmployees']}
        </SectionTitle>
        <PhoneNumber href={`tel:${bdoEmployeesPhone}`}>{bdoEmployeesPhone}</PhoneNumber>
      </Address>
      <LineBreak />
      {!hideSocialShare && (
        <>
          <SectionTitle>
            {resourceStrings['bdO.EventsWebinars.ContactAndConnect.Share']}
          </SectionTitle>
          <SocialMediaIntentList eventTypeDisplayName={eventTypeDisplayName} title={title} />
        </>
      )}
    </section>
  );
};

export default ContactAndConnect;
